import { useState } from "react";
import EntityAccessesDialog from "../components/ui/EntityAccessesDialog";
import { getAccessesAction } from "../components/ui/ListItemMenu";
import useI18n from "./useTranslations";

export const useEntityAccesses = <T extends { id: string; name?: string }>(entityType: string) => {
  const i18n = useI18n();
  const [item, setItem] = useState<T>();

  return {
    accessesAction: (target: T) => getAccessesAction(i18n, () => setItem(target)),
    accessesDialog: item && (
      <EntityAccessesDialog
        entityType={entityType}
        entityId={item.id}
        entityName={item.name}
        onClose={() => setItem(undefined)}
      />
    ),
  };
};
